import { useEffect } from 'react';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';

const serviceItems = [
  { icon: 'ri-film-line', title: '多元内容', desc: '电影、电视剧、综艺节目多类型覆盖，持续更新演示片库。' },
  { icon: 'ri-filter-3-line', title: '精准筛选', desc: '支持类型、地区、年份、热门程度等多维度组合筛选。' },
  { icon: 'ri-heart-line', title: '本地收藏', desc: '收藏与观看历史保存在您的浏览器本地，便于随时查看。' },
  { icon: 'ri-shield-check-line', title: '演示声明', desc: '站内播放器为前端演示功能，不接入任何真实流媒体服务。' },
];

export default function AboutPage() {
  useEffect(() => {
    document.title = '关于我们 - 在线免费观看';
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />

      <main className="flex-1 w-full max-w-[960px] mx-auto px-4 md:px-8 py-12">
        <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">关于我们</h1>
        <p className="text-sm text-foreground-600 leading-relaxed mb-10">
          “在线免费观看”致力于为广大影视爱好者提供海量且免费的在线视频资源展示，涵盖电影、电视剧、综艺节目等多种内容，
          支持分类浏览、筛选与在线演示播放，帮助用户通过多样分类快速找到心仪的影视内容。
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-12">
          {serviceItems.map((item) => (
            <div key={item.title} className="p-5 rounded-lg bg-background-100 border border-background-200">
              <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700 mb-4">
                <i className={`${item.icon} text-2xl`}></i>
              </span>
              <h3 className="font-heading font-semibold text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <section className="mb-12">
          <h2 className="font-heading text-xl font-bold text-foreground-950 mb-4">
            <a href="#contact" className="cursor-pointer">联系方式</a>
          </h2>
          <div id="contact" className="rounded-lg bg-background-100 border border-background-200 p-6 space-y-3 text-sm text-foreground-700">
            <p className="flex items-center gap-2"><i className="ri-mail-line text-primary-500"></i>客服邮箱：support@zaixianmianfei.example</p>
            <p className="flex items-center gap-2"><i className="ri-phone-line text-primary-500"></i>客服热线：400-000-0000（工作日 9:00-18:00）</p>
            <p className="flex items-center gap-2"><i className="ri-map-pin-line text-primary-500"></i>公司地址：北京市朝阳区影视文化产业园</p>
          </div>
        </section>

        <section>
          <h2 className="font-heading text-xl font-bold text-foreground-950 mb-4">
            <a href="#notice" className="cursor-pointer">版权声明与友情提示</a>
          </h2>
          <div id="notice" className="rounded-lg bg-background-100 border border-background-200 p-6 text-sm text-foreground-600 leading-relaxed space-y-3">
            <p>本站所展示的全部影视内容、海报图片、演员信息均为虚构演示数据，仅用于产品功能与页面设计展示，不代表真实影视作品，不提供任何真实视频播放或下载服务。</p>
            <p>站内收藏与观看历史功能仅保存在您当前使用的浏览器本地存储中，清除浏览器数据后相关记录将一并清除，本站不会在服务器端保存此类信息。</p>
            <p>© 2024 在线免费观看，保留所有权利。</p>
          </div>
        </section>
      </main>

      <SiteFooter />
    </div>
  );
}